import { TEAM_REPORT } from "../actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  isFetching: false,
  item: {
    teamName: "",
    members: []
  }
});

const order = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_REPORT["REQUEST"]:
      return state.merge({
        isFetching: true
      });
    case TEAM_REPORT["SUCCESS"]:
      return state.merge({ isFetching: false, item: { ...action.response } });
    default:
      return state;
  }
};

export default order;
